











import Vue from "vue";
import AppSidebar from "@/components/Sidebar/Sidebar.vue";
import { Aside, Container, Main } from "element-ui";

Vue.use(Container);
Vue.use(Aside);
Vue.use(Main);

export default Vue.extend({
    components: { AppSidebar },
});
